export { CarouselModule } from './carousel.module';
export { CarouselComponent } from './carousel.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-carousel/src/index.js
// module id = 948
// module chunks = 4